<template>
  <v-dialog persistent v-model="value" max-width="500">
    <v-form @submit.prevent="exportState">
      <v-card>
        <v-card-title class="headline">{{$t('Pages.Users.equipment_list')}}</v-card-title>

        <v-card-text>
          <v-layout column wrap>
            <v-flex xs12 md5>
              <ol v-if="state && state.length > 0">
                <li v-for="item in state" :key="item.product_id">
                  <p><span class="font-weight-medium">{{$t('Pages.Products.model.name')}}:</span> {{ item.product }}</p>
                  <p><span class="font-weight-medium">{{$t('Pages.Products.model.quantity')}}:</span> {{ item.quantity }}</p>
                </li>
              </ol>
              <p v-else class="font-weight-medium text-xs-center">{{$t('Pages.Users.empty_equipment_list')}}</p>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn @click="close">
            {{$t('Core.Fields.close')}}
          </v-btn>

          <v-btn dark color="success dark1" type="submit" :loading="loading" v-if="state && state.length > 0">
            {{$t('Pages.UserCheckoutForms.btn_export')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  export default {
  components: {},
  props: ['state', 'value', 'loading'],
  data: () => ({

  }),
  created () {
  },
  methods: {
    close(){
      this.$emit('close')
    },
    exportState(){
      this.$emit('exportState')
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
  .mv-20{
    margin-top: 20px;
    margin-bottom: 20px
  }
  .fs-16{
    font-size: 16px;
  }
</style>